import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import config from 'config/config.json';
import GALink from 'components/GALink';

function SellToUsPrompt({ hasSoldToLuxity, emptyItems = 'sales' }) {
  return (
    <Fragment>
      <div className="sales__item item u-text--center">
        <h6>
          {hasSoldToLuxity
            ? `You have no active ${emptyItems}. See what we can offer you.`
            : "You haven't sold to Luxity yet. See what we can offer you."}
        </h6>
        <div className="u-margin--bottom mt-10">
          <GALink
            href={`${config.LUXITY_SHOP_URL}/sell-to-us`}
            className="btn--luxity"
            label="Sell To Us"
            target="_blank"
            rel="noopener noreferrer">
            Sell To Us
          </GALink>
        </div>
      </div>
    </Fragment>
  );
}

const mapState = ({ profileStore }) => ({
  hasSoldToLuxity: profileStore.profile_data?.has_sold_to_luxity || false,
});

export default connect(mapState)(SellToUsPrompt);
